import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { apiGetProducts } from "../services/api";

const ProductContext = createContext();

// Normalize DB snake_case to camelCase used by frontend
const normalize = (p) => ({
  ...p,
  originalPrice: p.original_price ?? p.originalPrice ?? null,
});

export const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadProducts = useCallback(async () => {
    setLoading(true);
    try {
      const data = await apiGetProducts();
      setProducts(Array.isArray(data) ? data.map(normalize) : []);
    } catch {
      setProducts([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadProducts(); }, [loadProducts]);

  return (
    <ProductContext.Provider value={{ products, loading, reload: loadProducts }}>
      {children}
    </ProductContext.Provider>
  );
};

export const useProducts = () => useContext(ProductContext);
